import React from "react";

export function EditorToolsTopRight() {
  return (
    <div className="editor-tools editor-tools-top-right">

    </div>
  );
}
